import { Dispatch, forwardRef, SetStateAction } from 'react'
import './TextArea.css'
import { useTranslation } from 'react-i18next'
import { ReactComponent as IcPassed } from '../../../assets/svgs/icon/ic_passed.svg'
import { ReactComponent as IcError } from '../../../assets/svgs/icon/ic_error.svg'

export interface TextAreaInfoMsg {
    msg: string
    type: 'passed' | 'error'
}

interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    inputVal: string
    setInputVal?: Dispatch<SetStateAction<string>>
    title?: string
    infoMsg?: TextAreaInfoMsg
    isRequired?: boolean
    notShowInfo?: boolean
    containerStyle?: React.CSSProperties
    readOnlyStyle?: boolean
    minHeight?: number
    showCounter?: boolean
}

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(({
    title,
    infoMsg,
    inputVal,
    setInputVal,
    isRequired,
    notShowInfo,
    containerStyle,
    readOnlyStyle,
    minHeight = 200,
    showCounter,
    ...rest
}, ref) => {
    const { t } = useTranslation()

    const maxLength = rest.maxLength
    const isCounterVisible = showCounter && typeof maxLength === 'number'
    const isCounterFull = isCounterVisible && inputVal.length >= (maxLength as number)

    return (
        <div style={containerStyle ?? { padding: '10px 0' }}>
            {title &&
                <div className="common-textarea-title-container">
                    <span className="common-textarea-title">{title}</span>
                    {isRequired &&
                        <span className="common-textarea-required">{t('common.required')}</span>
                    }
                </div>
            }
            <div className="common-textarea-wrapper">
                <textarea
                    ref={ref}
                    className={`common-textarea ${readOnlyStyle ? 'read-only' : ''}`}
                    style={{ minHeight }}
                    {...rest}
                    value={inputVal}
                    onChange={(e) => {
                        setInputVal && setInputVal(e.target.value)
                        rest.onChange?.(e)
                    }}
                />
            </div>
            {(!notShowInfo || isCounterVisible) &&
                <div className="common-textarea-msg-wrapper">
                    {!notShowInfo && infoMsg &&
                        <>
                            {infoMsg.type === 'error' &&
                                <IcError
                                    height="12px"
                                    width="12px"
                                    color="var(--warning)"
                                />
                            }
                            {infoMsg.type === 'passed' &&
                                <IcPassed
                                    height="12px"
                                    width="12px"
                                    color="var(--primary)"
                                />
                            }
                            <span className={`common-textarea-msg ${infoMsg.type}`}>{infoMsg.msg}</span>
                        </>
                    }
                    {isCounterVisible &&
                        <span className={`common-textarea-counter ${isCounterFull ? 'full' : ''}`}>
                            {inputVal.length}/{maxLength}
                        </span>
                    }
                </div>
            }
        </div>
    )
})
